<div class="dialog-agent">
  <h1 mat-dialog-title>{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.DELETE-CERT' | translate }}</h1>
  <div mat-dialog-content>
    <ng-container *ngIf="data.alias; then showMsgAlias; else showMsgSize"></ng-container>
    <!-- caso 1 - individual -->
    <ng-template #showMsgAlias>
      <span>
        {{ 'GLOBAL.DELETE-INFO.CERT-ONE' | translate: { dataalias: data.alias } }}
      </span>
    </ng-template>
    <!-- caso 2 - grupal -->
    <ng-template #showMsgSize>
      <span>
        {{ 'GLOBAL.DELETE-INFO.CERT-MULTI' | translate: { datasize: data.size } }}
      </span>
    </ng-template>
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [mat-dialog-close]="true">
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.YES' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.NO' | translate }}</span>
    </button>
  </div>
</div>
